import * as React from 'react'

import Localization from '../../localization/LocalizationManager'
import { Button } from '../Button/Button'
import { LinkIcon } from '../icons/LinkIcon'
import { RemoveIcon } from '../icons/RemoveIcon'
import { ResourceCard } from '../ResourceCardList/ResourceCard'
import { IResourceCardModel } from '../ResourceCardList/types'
import Spinner from '../Spinner/Spinner'
import { useResourceLinkContext } from './ResourceLinkContext'

interface IProps {
  label: string
  cardModel?: IResourceCardModel | null
  leadingIcon?: React.ReactNode
  onOpenLinked?: () => void
  /** Shows the linked resource without the actions that link, change or unlink it. */
  readOnly?: boolean
}

export const ResourceLinkTrigger: React.FC<IProps> = ({
  label,
  cardModel,
  leadingIcon,
  onOpenLinked,
  readOnly,
}) => {
  const { linkedItem, openPicker, unlinkCurrent, loading } =
    useResourceLinkContext()

  if (loading) {
    return (
      <div className="tw:flex tw:items-center tw:justify-center tw:px-4 tw:py-4">
        <Spinner size="sm" />
      </div>
    )
  }

  if (!linkedItem) {
    if (readOnly) return null
    return (
      <div className="tw:flex tw:justify-end tw:px-4 tw:py-4">
        <Button variant="outline" size="lg" onClick={openPicker}>
          <LinkIcon data-icon="inline-start" size="sm" />
          {Localization.translator.linkToX(label)}
        </Button>
      </div>
    )
  }

  return (
    <div className="tw:px-4 tw:py-4">
      <div className="tw:flex tw:items-end tw:justify-between tw:mb-2">
        <span className="tw:text-label-lg tw:text-muted-foreground">
          {Localization.translator.linkedToX(label)}
        </span>
        {!readOnly && (
          <div className="tw:flex tw:items-center tw:gap-2">
            <Button variant="outline" onClick={openPicker}>
              {Localization.translator.change_verb}
            </Button>
            <Button variant="outline" onClick={unlinkCurrent}>
              <RemoveIcon data-icon="inline-start" size="sm" />
              {Localization.translator.unlink_verb}
            </Button>
          </div>
        )}
      </div>
      {cardModel ? (
        <ResourceCard.Standard
          model={cardModel}
          variant="outlined"
          onClick={onOpenLinked || (readOnly ? undefined : openPicker)}
          leading={leadingIcon}
        />
      ) : (
        <div
          className="tw:flex tw:items-center tw:gap-2 tw:p-3 tw:rounded-lg tw:border tw:border-solid tw:border-border tw:cursor-pointer hover:tw:bg-muted"
          onClick={onOpenLinked || (readOnly ? undefined : openPicker)}
        >
          <span className="tw:text-body-md tw:text-foreground tw:font-semibold">
            {linkedItem.name}
          </span>
        </div>
      )}
    </div>
  )
}
